export type TrafficHourlyCapacityProfile = {
  hour: number
  label: string
  value: number
}

export type TrafficSpeedDemandProfile = {
  hour: number
  label: string
  speed: number
  demand: number
}

export type TrafficApiResponse = {
  avg_speed_kmh: number
  by_day: Array<{
    congestion_pct: number
    day: string
  }>
  by_hour: Array<{
    congestion_pct: number
    hour: number
  }>
  capacity_vehicles: number
  generated_at: string
  demand_peak_hour: number
  location: {
    lat: number
    lng: number
  }
  metrics: {
    avg_congestion_pct: number
    avg_distance_15min_km: number
    avg_speed_highway_kmh: number
    avg_speed_rush_hour_kmh: number
    avg_travel_time_10km_min: number
    highway_trip_ratio_pct: number
  }
  model_window: string
  peak_hour: string
  radius_km: number
  source: string
  capacity_profile: Array<{
    hour: number
    vc_ratio: number
  }>
  speed_demand_profile: Array<{
    demand_pct: number
    hour: number
    speed_kmh: number
  }>
  worst_day: string
  zone: string
}

export type TrafficData = {
  averageSpeed: number
  totalCapacity: number
  peakHour: string
  capacityProfile: TrafficHourlyCapacityProfile[]
  speedDemandProfile: TrafficSpeedDemandProfile[]
}

const formatHourLabel = (hour: number) => `${hour}:00`
const sortByHour = <T extends { hour: number }>(items: T[]) =>
  [...items].sort((a, b) => a.hour - b.hour)

export const normalizeTrafficData = (data: TrafficApiResponse): TrafficData => ({
  averageSpeed: data.avg_speed_kmh,
  totalCapacity: data.capacity_vehicles,
  peakHour: formatHourLabel(data.demand_peak_hour),
  capacityProfile: sortByHour(data.capacity_profile).map((item) => ({
    hour: item.hour,
    label: formatHourLabel(item.hour),
    value: item.vc_ratio,
  })),
  speedDemandProfile: sortByHour(data.speed_demand_profile).map((item) => ({
    hour: item.hour,
    label: formatHourLabel(item.hour),
    speed: item.speed_kmh,
    demand: item.demand_pct,
  })),
})
